import React from 'react';
import AdminResourceManagerPage from '../../components/admin/AdminResourceManagerPage';

export default function AdminMonitoringDocumentsPage() {
  return (
    <AdminResourceManagerPage
      moduleKey="monitoringDocuments"
      title="Documentos da Monitoria"
      description="Substitua os PDFs do Manual e dos Editais exibidos na página pública do Programa de Monitoria."
      createLabel="Novo documento"
      emptyMessage="Nenhum documento cadastrado para a Monitoria."
    />
  );
}
